import { render, staticRenderFns } from "./BusinessScopeRedirect.vue?vue&type=template&id=f257b3c4&"
import script from "./BusinessScopeRedirect.vue?vue&type=script&lang=js&"
export * from "./BusinessScopeRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports